import { LANGUAGES } from '../data';

export default function Languages() {
  return (
    <section className="section" id="languages">
      <div className="container">
        <div className="section-head">
          <span className="eyebrow">9 languages included</span>
          <h2>One app, a world of conversations</h2>
          <p>From Cantonese to Italian — all built in, no add-ons, no subscriptions.</p>
        </div>
        <div className="langs">
          {LANGUAGES.map((l) => (
            <div className="lang" key={l.name}>
              <span className="flag">{l.flag}</span>
              <span>{l.name}</span>
              <span className="native">{l.native}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
